import InspectionItemHtml from './inspection.item.html';

export function InspectionItemDirective () {
  return {
    restrict   : 'E',
    templateUrl: InspectionItemHtml,
    controller : 'InspectionItemCtrl',
    scope      : {
      company   : '=',
      inspection: '=',
      item      : '=',
      readonly  : '=',
      vehicle   : '='
    }
  };
};